import request from '@/utils/request'


// 查询广告列表
export function listAdvertisement(query) {
  return request({
    url: '/video/advertisement/list',
    method: 'get',
    params: query
  })
}

// 查询广告分页
export function pageAdvertisement(query) {
  return request({
    url: '/video/advertisement/page',
    method: 'get',
    params: query
  })
}

export function getGatherList(query) {
  return request({
    url: '/video/videoAdvertisement/getGatherList',
    method: 'get',
    params: query
  })
}

export function bingGather(data) {
  return request({
    url: '/video/videoAdvertisement/bingGather',
    method: 'post',
    data: data
  })
}

// 查询广告详细
export function getAdvertisement(data) {
  return request({
    url: '/video/advertisement/detail',
    method: 'get',
    params: data
  })
}
export function changeIsOpen(data) {
  return request({
    url: '/video/advertisement/changeIsOpen',
    method: 'post',
    data: data
  })
}
// 新增广告
export function addAdvertisement(data) {
  return request({
    url: '/video/advertisement/add',
    method: 'post',
    data: data
  })
}

// 修改广告
export function updateAdvertisement(data) {
  return request({
    url: '/video/advertisement/edit',
    method: 'post',
    data: data
  })
}

// 删除广告
export function delAdvertisement(data) {
  return request({
    url: '/video/advertisement/delete',
    method: 'post',
    data: data
  })
}
